export const ERROR_MESSAGES = {
  GENERIC_CHAT_ERROR: "I can't answer that question. Please try again with another question",
  INPUT_QUERY_TOO_LONG: "Your query is too long. Please shorten it.",
} as const;
